<template>
  <section class="vcenter">
    <form class="vcenter-form" @submit.prevent="login">

      <h1>{{$t('login.title')}}</h1>

      <b-message v-if="errorMessage" type="is-danger">{{ errorMessage }}</b-message>

      <b-field :label="$t('login.field-login')">
        <b-input v-model="email" type="email" />
      </b-field>
      <b-field :label="$t('login.field-password')" >
        <b-input v-model="password" type="password" />
      </b-field>

      <div class="form-buttons">
        <button class="button is-primary" type="submit">{{$t('login.btn-valider')}}</button>
        <div class="right">
          <router-link to="/password-reset" class="small">{{$t('login.btn-reset')}}</router-link>
        </div>
      </div>

      <b-loading :active="loading" :is-full-page="false" />
    </form>
  </section>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: '',
      errorMessage: null,
      loading: false,
    }
  },
  created () {
    if (process.env.NODE_ENV === 'dev') {
      this.email = 'simon@tarchichi.com'
      this.password = 'test'
    }
  },
  methods: {
    async login () {
      this.errorMessage = null
      this.loading = true
      try {
        const data = await this.$api.post('/login', {
          email: this.email,
          password: this.password,
        })
        if (!data || !data.token) {
          throw new Error('No token found')
        }
        await this.$store.dispatch('getUser', data.token)
        this.$router.push('/portefeuille')
      } catch (e) {
        if (e.response && e.response.data && e.response.data.error) {
          this.errorMessage = e.response.data.error
        } else {
          // Affectation et non concaténation : errorMessage vaut null ici, le
          // « += » affichait « nullNetwork Error ».
          this.errorMessage = e.message || this.$t('login.error1')
        }
      }
      this.loading = false
    },
  }
}
</script>
